export async function copyToClipboard(text) {
    if ('clipboard' in navigator) {
        await navigator.clipboard.writeText(text);
    } else {
        document.execCommand('copy', true, text);
    }
}
